<template>
<!-- 审核文件后复核-预约用药 -->
  <div class="agentUpload" v-if="!isLoading">
    <div class="appointment-container">
        <!-- 邮寄驳回提示 -->
        <!-- <div class="upload-status" v-if="(itemStatus=='审核不通过')&&showReasons" >
          <div class="status"><img width="16px" style="margin-right:3px;" src="/static/upload/refuseIcon.png" />邮寄材料审核不通过</div>
          <div class="reason">驳回原因：<br />
            <div v-for="item,index in reasons" :key="index">
              {{item.name}}: {{getReason(item.result.reason)}}; <br />
            </div>
          </div>
        </div> -->

        <div class="appointment-list">
          <van-cell-group  :border="false">
            <template #title>
              <span class="custom-title">{{text2}}</span>
            </template>
            <van-cell :border="false" @click="goUpload(item)" v-for="item,index in items" :key="index">
              <template #title>
                <span class="custom-title">
                  <!-- <span class="custom-title" :style="{color:citem.result.status=='审核不通过'?'red':''}"> -->
                  <div :style="{'color':item.result.status=='审核不通过'?'red':''}">{{item.name}}</div>
                    <div class="appointment-status" v-if="item.result.status=='审核不通过'" >
                      <div class="img-status">
                        <img width="16px" style="margin-right:4px;margin-top:4px;" src="/static/upload/refuseIcon.png" />
                        驳回原因：{{item.result.reasons}}
                      </div>
                    </div>
                </span>
              </template>
              <div style="width:100%;display:flex;justify-content:center;">
                <img :src="getImgSrc(item.result.status,item)" width="55px" height="55px" />
                <!-- <img :src="getImgSrc('待审核', { attach: [] })" width="55px" /> -->
              </div>
            </van-cell>
          </van-cell-group>
        </div>


    </div>
    <div class="btn" >
      <van-button plain round class="btn1" @click="deleteAgentApply"  :disable="nextBtnDisabled" color="#0AA8AF">撤销申请</van-button>
      <van-button round  class="btn2" @click="goNext"  :disable="nextBtnDisabled" color="#0AA8AF">提交</van-button>
    </div>
  </div>
</template>
<script>
import { saveAgentApply,deleteApply,getCheckItems,getAgentApply } from '@/api/patient'
import Vue from "vue";
import { mapState } from "vuex";
import { Toast, Notify } from "vant";

Vue.use(Toast);
export default {
  data() {
    return {
      text2: "申请代领需要的材料",
      // btntxt:"提交",
      // disabled:false,//禁用提交按钮
      isLoading:true,//加载中不显示按钮
      category:"代领人领药审核",

      nextBtnDisabled:false,
      active:'0',

      papid:"",
      patient_id:"",

      items:[],

      apply_id:''


    };
  },
  computed: {
    ...mapState(['patientOne', 'userInfo','patientInfo']),
  },
  async created(){
  },
  async mounted() {
    Toast.loading({ duration: 0,  forbidClick: true }); 

      if (this.$route.query.active) {
        this.active = parseInt(this.$route.query.active);
      }
      if (this.$route.query.follow) {
        this.follow = this.$route.query.follow;
      }
      // console.log(this.active, this.$route.query)
      if (this.userInfo.patient) {
        this.papid = this.userInfo.patient.papid
        this.patient_id = this.userInfo.patient.id
      }

      await this.getData()

      Toast.clear()
      this.$forceUpdate()
    },
  methods: {
    async getData() {
        
        await getAgentApply({papid: this.papid,}).then(res=>{
          if(res.data){
            this.apply_id=res.data.id
          }else{
            this.$router.go(-1)
          }
        })
        let ci = await getCheckItems({
          papid: this.papid,
          category: this.category,
          // phase: res.data.patient.receive_phase
        })
        console.log(ci.data[0].data)
        this.items=ci.data[0].data

        this.isLoading = false
      },
      goUpload(item, name) {
        console.log("goUpload", item.category)
        console.log(item.id)
        console.log(this.papid)
        console.log(item.category)
        console.log(this.active)
        console.log(this.follow)
        this.$router.push({
          name: 'AgentUploadItem',
          query: {
            id: item.id,
            papid: this.papid,
            category: item.category,
            active: this.active,
            follow: this.follow
          }
        })
      },
    //通过状态计算图片地址
    getImgSrc(status, item) {
      const fileUrl = "/static/upload/";
      const format = ".png";
      let imgName = "awaitUpload";
      // console.log(item,status)
      if (status == "审核不通过") {
        imgName = "refuse";
      } else if (status == "审核通过") {
        imgName = "passed";
      } else if (status == "待审核" && item.attach.length > 0) {
        //已上传
        imgName = "uploaded";
      } else if (status == "待审核") {
        //未上传
        imgName = "awaitUpload";
      } else {
        console.log("getImgSrc出错");
      }
      imgName = fileUrl + imgName + format;

      return imgName;
    },
    //下一步
    goNext(){
        let item = this.items
        let allup = true
        console.log("item",item)
        for (let i in item) {
          let ele = item[i]
          console.log("ele",ele)
          if (ele.result.status == "未上传" || ele.attach.length < 1) {
            if (ele.is_required == "1") {
              allup = false
              Toast('请完善资料')
              return
            }
          } else if (ele.result.status == "审核不通过") {
            Toast('您有驳回的材料，请重新上传')
            allup = false
            return
          }
        }
        if(allup){
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true
          });
          saveAgentApply({
            papid: this.papid,
            category: [this.category],//
          }).then(res => {
            this.$router.replace({
              name: "Timeline",
            });
            Toast.clear();
          }).catch(err => {
            this.nextBtnDisabled = false;
            Toast.clear();
            Toast(err.response.data.message);
          })
        }
    },
    // toastText(text){
    //   Toast(text)
    // },
    // getReason(reason){
    //   let str='';
    //   reason.forEach(ele=>{
    //     str+=ele
    //   })
    //   return str
    // },
    async deleteAgentApply(){
      await deleteApply({ papid: this.papid, apply_id:this.apply_id }).then(res=>{
        if(res.data){
            // Toast.success('撤销申请成功');
            this.$router.replace({ name: "Timeline" });
        }
      }).catch(err => {
          Toast.fail('撤销申请失败');
      })
    },


  },
};
</script>
<style lang="less">
.agentUpload {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  // box-sizing: border-box;
  .appointment-container{
    min-height: calc(90vh - 50px);
    .upload-status {
      box-sizing: border-box;
      padding: 10px 15px;
      margin: 16px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .status{
        display: flex;
        align-items: center;
      }
      &.red {
        color: @red;
      }
    }
  
  .appointment-list {
    box-sizing: border-box;
    margin: 16px;
    border-radius: 10px;
    box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0);
    overflow: hidden;
    .van-cell__title {
      flex: 5;
    }
    .van-cell__value{
      flex: 2;
      display:flex;
      justify-content:flex-start;
      align-items:center;
      .alignment-flex{
        display:flex;
        justify-content:flex-start;
        align-items:flex-start;
      }
    }
    .appointment-status {
      box-sizing: border-box;
    //   padding: 10px 15px;
    //   margin: 16px;
      border-radius: 10px;
      overflow: hidden;
    //   background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .img-status{
        display: flex;
        align-items: flex-start;
      }
      &.red {
        color: @red;
      }
    }
  }
  .van-cell-group__title {
    background: #0aa8af;
    color: #fff;
    padding: 10px;
    .custom-title{
      margin-left: 20px;
    }
    &::after {
      content: "";
      width: 4px;
      height: 15px;
      background-color: #e8f4a6;
      position: absolute;
      left: 30px;
      border-radius: 2px;
    }
  }
  }
   .btn{
      display: flex;
      justify-content:space-between;
      width: 100%;
      padding: 10px;
      // background-color: white;
      margin: 0;
      .van-button{
        margin: 0 5px;
        white-space: nowrap;
      }
      .btn1{flex-grow: 1;}
      .btn2{flex-grow: 99;}
    }
}
</style>